import { FC } from 'react';
import { Box, HStack } from '@chakra-ui/react';
import { ContentContainerType } from 'types/enums';
import { config } from 'config';
import { AccountSettings } from 'app/components/Settings/AccountSettings';
import { ChakraPageTitle } from 'app/components/Core';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { Storage } from 'app/components/Storage';
import { AppSettings, ThemeSettings } from 'app/components/Settings';
import { useIsMobile } from 'app/utils/hooks';
import { MobileSettingsInformation } from 'app/components/Settings/MobileSettingsInformation';
import { AppStoreNotification } from 'app/components/AppStoreNotification';
import { PrivacySettings } from 'app/components/Settings/PrivacySettings';
import { Import } from 'app/components/Settings/Import';

export const Settings: FC = () => {
  const isMobile = useIsMobile();

  return (
    <ContentContainer
      type={ContentContainerType.FORM}
      display="block"
      pb="60px"
      px={6}
    >
      <HStack alignItems="center" py={isMobile ? 4 : 7}>
        <ChakraPageTitle flex={1}>Settings</ChakraPageTitle>
      </HStack>
      {isMobile && <AppStoreNotification />}
      <Storage />
      <AccountSettings />
      {config.isElectronBuild && (
        <Box>
          <AppSettings />
        </Box>
      )}
      {isMobile && (
        <Box>
          <MobileSettingsInformation />
        </Box>
      )}
      <Box pb={7}>
        <PrivacySettings />
      </Box>
      <Box pb={7}>
        <ThemeSettings />
      </Box>
      <Box>
        <Import />
      </Box>
    </ContentContainer>
  );
};
